import React from 'react';

const AWS_S3 = () => {
  return (
    <div>
      <h1>AWS_S3</h1>
      <p>This is the AWS_S3 component.</p>
    </div>
  );
};

export default AWS_S3;
